<template>
        <div class='h-topogjxx-sidebj'>
          <div class='h-ainfoBg'>
    <div class='h-ainfo'>
      <span class='icon hero-icon hero-icon-detailcode'></span>
      <span>{{$t('每个节点分类标签最多5个；每个节点污点最多1个')}}</span>
    </div>
  </div>
      <ejs-grid
        ref="grid"
        id="grid"
        :dataSource="instanceData"
        :allowPaging="true"
        :pageSettings="pageSettings"
      >
        <e-columns>
          <e-column field="id" :visible="false"></e-column>
          <e-column field="environmentId" :visible="false"></e-column>
          <e-column field="equipmentId" :visible="false"></e-column>
          <e-column
            field="equipmentName"
            :headerText="$t('名称')"
            width="140"
            textAlign="Center"
            :allowEditing="false"
          ></e-column>
          <e-column
            field="labels"
            :headerText="$t('分类标签')"
            width="240"
            textAlign="Center"
            :template="labelTemplate"
          ></e-column>
          <template>
            <e-column
              field="taints"
              :headerText="$t('污点')"
              width="120"
              textAlign="Center"
              :template="empTemplate"
            ></e-column>
          </template>
        </e-columns>
      </ejs-grid>
    </div>
</template>
<script>
import { Edit, Toolbar } from "@syncfusion/ej2-vue-grids";
import empTemplate from "./taintsTemplate";
import labelTemplate from "./labelsTemplate";
import { EventBus } from "../../../plugins/eventBus";
export default {
  name: "NodesDetail",
  components: { empTemplate },
  components: { labelTemplate },

  data() {
    return {
      empTemplate(args) {
        return {
          template: empTemplate
        };
      },
      labelTemplate(args) {
        return {
          template: labelTemplate
        };
      },
      environmentId: "",
      instanceData: [],
      selectIndexes: [],
      dateFormat: {
        type: "date",
        format: "yyyy/MM/dd HH:mm:ss"
      },
      editSettings: {
        allowEditing: true,
        allowAdding: false,
        allowDeleting: true
      },
      toolbar: ["Edit", "Update", "Cancel"],
      toolbarItem: [
        {
          prefixIcon: "icon hero-icon hero-icon-refresh",
          tooltipText: "编辑",
          click: this.editGrid
        },
        {
          prefixIcon: "icon hero-icon hero-icon-refresh",
          tooltipText: "更新",
          click: this.updateGrid
        },
        {
          prefixIcon: "icon hero-icon hero-icon-refresh",
          tooltipText: "取消",
          click: this.cancelGrid
        }
      ],
      toolbarItems: [
        {
          prefixIcon: "icon hero-icon hero-icon-refresh",
          tooltipText: this.$t("Alarm.refresh"),
          click: this.refreshGrid
        }
      ],
      data: [],
      instanceNum: 0
    };
  },
  provide: {
    grid: [Edit, Toolbar]
  },
  mounted() {
    // this.getInstanceList();
  },
  methods: {
    init(selectedRoleIds) {
      this.selectedRoleIds = selectedRoleIds;
    },
    getInstanceList() {
      const url = "/lte/ems/user/query";
      this.page.pageNo = this.$refs.pager.ej2Instances.currentPage;
      const params = {
        params: {
          username: this.keyword,
          pageNo: this.page.pageNo,
          pageSize: this.pageSettings.pageSize
        }
      };

      const That = this;
      this.axios.get(url, params).then(response => {
        const result = response.data.result;
        result.forEach(v => {
          let date = new Date();
          date.setTime(v.createTime);
          v.createTime = date;
        });
        That.page.totalRecordsCount = response.data.totalCount;
        That.instanceData = result;
      });
    },
    dataBound() {
      this.$refs.instanceGrid.selectRows(this.selectIndexes, false);
    },
    clearData() {
      this.$refs.environmentId = "";
    },
    setEnvId(envid) {
      const That = this;
      this.$refs.environmentId = envid;
      this.$axios
        .get("/lte/ems/env/getEnvironEquipByEnvid?id=" + envid)
        .then(response => {
          const res = response.data.resultVal;
          That.instanceData = res;
          console.log(JSON.stringify(res));
        });
    },
    editGrid() {},
    updateGrid() {
      const result = this.$refs.grid.getSelectedRecords();
    },
    cancelGrid() {},
    getGridData() {
      return this.$refs.grid.getCurrentViewRecords();
    },
    getGridDataNew() {
      const data = this.$refs.grid.getCurrentViewRecords();
      const taintsListCheck = [];
      const labelsListCheck = [];
      for (var i = 0; i < data.length; i++) {
        const id = data[i].id;
        const taintsList = document.getElementById(id).getElementsByClassName("e-chip");
        const labelsList = document.getElementById(id + ",3").getElementsByClassName("e-chip");
        console.log("labelsList", labelsList);
        const taintsListNew = [];
        const labelsListNew = [];
        for (var j = 0; j < taintsList.length; j++) {//组成新污点list
          if (undefined !== taintsList[j]) {
            
            taintsListCheck.push(taintsList[j].innerText);
            taintsListNew.push(taintsList[j].innerText);
          }
        }
        for (var k = 0; k < labelsList.length; k++) {//组成新分类标签list
          if (undefined !== labelsList[k]) {
            labelsListCheck.push(labelsList[k].innerText);
            labelsListNew.push(labelsList[k].innerText);
          }
        }
        console.log("taintsListNew====", taintsListNew);
        console.log("labelsListNew====", labelsListNew);
        if(taintsListNew.length>1){
           EventBus.$emit("toast", {
              type: "warning",
              content: "每个节点污点最多1个"
            });
            return false;
        }
        if(labelsListNew.length>5){
           EventBus.$emit("toast", {
              type: "warning",
              content: "每个节点分类标签最多5个"
            });
            return false;
        }
        var labelNary = labelsListNew.sort();
        for (var c = 0; c < labelsListNew.length; c++) {//校验每行的污点是否重复
          if (labelNary[c] == labelNary[c + 1]) {
            EventBus.$emit("toast", {
              type: "warning",
              content: "分类标签重复"
            });
            return false;
          }
        }
        taintsListNew = taintsListNew.join(";");
        labelsListNew = labelsListNew.join(";");
        data[i].taints = taintsListNew;
        data[i].labels = labelsListNew;

      }
      console.log("labelsListCheck",labelsListCheck)
      console.log("taintsListCheck",taintsListCheck)
      var nary = taintsListCheck.sort();
      console.log("nary",nary)
      for (var z = 0; z < taintsListCheck.length; z++) {//校验每行的污点是否重复
          if (nary[z] == nary[z + 1]) {
            EventBus.$emit("toast", {
              type: "warning",
              content: "污点重复"
            });
            return false;
          }
        }
        for (let x = 0; x <taintsListCheck.length; x++) {//校验每个分类标签与污点是否重复
          for (let y = 0; y <labelsListCheck.length; y++) {
            if (taintsListCheck[x] == labelsListCheck[y]) {
            EventBus.$emit("toast", { type: "warning",content: "分类标签与污点重复"});
            return false;            }
          }
        }
      return data;
    },

  }
};
</script>
